<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            UserButtons(:item="item", @itemUpdated="$emit('itemUpdated')")

        .column
          status(:status="item.enabled? 'ACTIVE': 'PENDING_REVIEW'")
          .label U{{item.id}}
          .field {{item.username}}
        .column
          .label Federation
          .field(v-if="item.federation !== null") {{item.federation.name}}
        .column
          .label Email
          .field {{item.email}}
        .column
          .label Role
          .field {{item.roles.map(u => u.name).join(', ')}}
            //span(v-for="role in item.roles") {{role.name}}
        .column
          .label Created
          .field {{item.created_at}}
        .column.shrink
          router-link(:to="{name:'user', params:{id:item.id}}")
            i.fa.fa-angle-right.fa-3x.action
</template>

<script>
  import CardN from '../structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import Status from '../structure/ui/Status'
  import UserButtons from '../structure/ui/actions/UserButtons'

  export default {
    name: 'User',
    components: {UserButtons, Status, Dropdown, CardN},
    props: ['item', 'type']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// User.vue?5b9ef178